import {apsCommands} from "../../shared/dto/aps.commands";
import {apsViewModels} from "../../shared/dto/APS.ViewModels";
import {apsCommon} from "../../shared/dto/aps.common";
import * as angular from 'angular';
import HttpServiceName, {HttpService} from "../http/http.service";
import {Endpoints} from "../../shared/config/constant.module";

export interface JobService {
  getJobs(): angular.IPromise<apsViewModels.JobItem[]>;
  addJob(command: apsCommands.AddJob): angular.IPromise<any>;
  saveJob(command: apsCommands.UpdateJob): angular.IPromise<any>;
  deleteJob(job: apsViewModels.JobItem): angular.IPromise<any>;

  getCustomers(): angular.IPromise<apsCommon.IdAndName[]>;
  getGlassColors(): angular.IPromise<apsCommon.IdAndName[]>;
  getWareClasses(): angular.IPromise<apsCommon.IdAndName[]>;
  getProcesses(): angular.IPromise<apsViewModels.JobProcess[]>;
  getDescriptions(): angular.IPromise<string[]>;
  getMolds(): angular.IPromise<string[]>;
  getFinishes(): angular.IPromise<string[]>;
  getTargetMolds(plantId: string): angular.IPromise<string[]>;
  getTargetFinishes(plantId: string, mold: string): angular.IPromise<string[]>;  
}

export default angular
  .module('aps.services.job', [HttpServiceName])
  .service('jobService', function (httpService: HttpService): JobService {

    var getJobs = () => {
      return httpService.get<apsViewModels.JobItem[]>(Endpoints.JOBS);
    };

    var addJob = (command: apsCommands.AddJob) => {
      return httpService.post<any>(Endpoints.JOBS, command);
    };

    var saveJob = (command: apsCommands.UpdateJob) => {
      return httpService.put<any>(Endpoints.JOBS, command);
    };

    var deleteJob = (job: apsViewModels.JobItem) => {
      return httpService.delete<any>(Endpoints.JOBS + '/' + job.id);
    };

    var getCustomers = () => {
      return httpService.get<apsViewModels.JobItem[]>(Endpoints.CUSTOMERS);
    };

    var getGlassColors = () => {
      return httpService.get<apsViewModels.JobItem[]>(Endpoints.GLASS_COLORS);
    };

    var getWareClasses = () => {
      return httpService.get<apsViewModels.JobItem[]>(Endpoints.WARE_CLASSES);
    };

    var getProcesses = () => {
      return httpService.get<apsViewModels.JobProcess[]>(Endpoints.JOB_PROCESSES);
    };

    var getDescriptions = () => {
      return httpService.get<string[]>(Endpoints.JOB_DESCRIPTIONS);
    };

    var getMolds = () => {
      return httpService.get<string[]>(Endpoints.JOB_MOLDS);
    };

    var getFinishes = () => {
      return httpService.get<string[]>(Endpoints.JOB_FINISHES);
    };

    var getTargetFinishes = (plantId: string, mold: string) => {
      return httpService.get<string[]>(Endpoints.JOB_TARGET_FINISHES, {plantId: plantId, mold: mold});
    };

    var getTargetMolds = (plantId: string) => {
      return httpService.get<string[]>(Endpoints.JOB_TARGET_MOLDS, {plantId: plantId});
    };

    return {
      getJobs: getJobs,
      addJob: addJob,
      saveJob: saveJob,
      deleteJob: deleteJob,
      getCustomers: getCustomers,
      getGlassColors: getGlassColors,
      getWareClasses: getWareClasses,
      getProcesses: getProcesses,
      getDescriptions: getDescriptions,
      getMolds: getMolds,
      getFinishes: getFinishes,
      getTargetFinishes: getTargetFinishes,
      getTargetMolds: getTargetMolds
    };
  })
  .name;


// WEBPACK FOOTER //
// ./src/app/services/jobs/job.service.ts